import React from 'react';
import { useTranslation } from 'react-i18next';

export interface PageTitleProps {
  title?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  const { t } = useTranslation();
  const siteName = t('components.appHeader.title');
  return <title>{title ? `${title} | ${siteName}` : siteName}</title>;
};

export default PageTitle;
